import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import { TabBar } from '../components/TabBar';

type TabType = 'home' | 'moms' | 'events' | 'forum';

export const LAST_TAB_PATH_KEY = 'moms:lastTabPath';

export function TabLayout() {
  const location = useLocation();

  useEffect(() => {
    try {
      sessionStorage.setItem(LAST_TAB_PATH_KEY, location.pathname + location.search);
    } catch { /* ignore */ }
  }, [location.pathname, location.search]);

  // Determine active tab based on current path
  const getActiveTab = (): TabType => {
    const path = location.pathname;
    if (path === '/home') return 'home';
    if (path.startsWith('/moms')) return 'moms';
    if (path.startsWith('/events')) return 'events';
    if (path.startsWith('/forum')) return 'forum';
    return 'home';
  };

  const activeTab = getActiveTab();

  return (
    <>
      <Outlet />
      <TabBar activeTab={activeTab} />
    </>
  );
}